module.exports = __webpack_public_path__ + "media/images/thumb_foot-221ed4e2.png";